import { useState, useRef, useLayoutEffect } from "react";

const useColumnResizing = (fields, defaultWidth = 150, extraPadding = 16) => {
  const headerRefs = useRef({});
  const [headerWidths, setHeaderWidths] = useState(
    fields.reduce((acc, field) => {
      acc[field.key] = defaultWidth;
      return acc;
    }, {})
  );
  const [tableWidths, setTableWidths] = useState(headerWidths);

  const handleResize =
    (fieldKey) =>
    (event, { size }) => {
      setHeaderWidths((prev) => ({
        ...prev,
        [fieldKey]: size.width,
      }));
    };

  const handleResizeStop =
    (fieldKey) =>
    (event, { size }) => {
      setTableWidths((prev) => ({
        ...prev,
        [fieldKey]: size.width,
      }));
    };

  useLayoutEffect(() => {
    const newWidths = {};
    fields.forEach((field) => {
      const el = headerRefs.current[field.key];
      if (el) {
        newWidths[field.key] = el.clientWidth + extraPadding;
      } else {
        newWidths[field.key] = defaultWidth;
      }
    });
    setHeaderWidths(newWidths);
    setTableWidths(newWidths);
  }, [fields, defaultWidth, extraPadding]);

  return {
    headerRefs,
    headerWidths,
    tableWidths,
    handleResize,
    handleResizeStop,
  };
};

export default useColumnResizing;
